import { useContextState } from '../../../../../../../hooks/theme'
import { SxProps, Theme } from '@mui/system'

export const useVersionListStyles = () => {
  const { colors: color } = useContextState()

  const listColumnHeader: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: '14px',
    py: '6px',
    fontSize: '14px',
    fontWeight: 500,
    color: `${color.color10}`,
    backgroundColor: `${color.color10}18`,
    borderBottom: `1px solid ${color.color10}50`,
  }

  const listColumnCounter: SxProps<Theme> = {
    fontSize: '12px',
    fontWeight: 500,
    color: color.color45,
  }

  const listContainer: SxProps<Theme> = {
    flex: 1,
    overflowY: 'auto',
    maxHeight: '310px',
    p: '12px 16px',
  }

  const listItemRow: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    border: `1px solid ${color.color10}50`,
    borderRadius: '4px',
    cursor: 'pointer',
    mb: '4px',
    minHeight: '50px',
    py: '6px',
    '&:hover': {
      backgroundColor: `${color.color10}22`,
    },
  }

  const checkboxRowAll: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${color.color10}50`,
    borderRadius: '4px',
    cursor: 'pointer',
    mb: '4px',
    height: '50px',
    '&:hover': {
      backgroundColor: `${color.color10}22`,
    },
  }

  const selectionControl: SxProps<Theme> = {
    padding: '9px',
    '& .MuiSvgIcon-root': {
      fontSize: '1.5rem',
    },
  }

  return {
    colors: color,
    listColumnHeader,
    listColumnCounter,
    listContainer,
    listItemRow,
    checkboxRowAll,
    selectionControl,
  }
}
